export default __webpack_public_path__ + "static/media/proximanova-regular.a6d66dc8.WOFF";